import React from 'react';

const MediaSection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 3xl:grid-cols-4 gap-3 md:gap-6">{children}</div>
  );
};

export default React.memo(MediaSection);
